import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class JsDomWindowService {
    public get nativeWindow(): Window {
        return window;
    }
}
